<template>
    <div class="iq-top-navbar admin-header-wrap">
        <div class="iq-navbar-custom">
            <nav class="navbar navbar-expand-lg navbar-light p-0">
                <div class="iq-navbar-logo d-flex align-items-center justify-content-between">
                    <img src="../../assets/images/dashboard/header-toggle-icon.svg" class="mobile-sidebar-toggle wrapper-menu" alt="toggle icon">
                    <router-link to="/" class="header-logo" exact> 
                        <img src="../../assets/images/dashboard/dash-logo.svg" class="img-fluid rounded-normal light-logo" alt="logo">
                    </router-link>
                </div>
            </nav>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HeaderLayout',
    data() {
        return {
            img_url: process.env.VUE_APP_IMG_URL,
            isDarkMode: localStorage.getItem("darkMode") === "true"
        };
    },
    async mounted() {
        this.setDarkMode();

    },
    computed: {
        darkMode() {
            return this.$store.state.isDarkMode
        },
    },
    watch: {
        async darkMode(newValue) {
            this.setDarkMode();
            return newValue
        },
    },
    methods: {
        handleDarkModeChange(event) {            
            const checked = event.target.checked;
            this.isDarkMode = checked;
            localStorage.setItem("darkMode", checked);
            this.setDarkMode();
        },
        setDarkMode() {
            const darkMode = localStorage.getItem("darkMode") === "true";
            this.$store.state.isDarkMode = darkMode
            if (darkMode) {
                document.body.classList.add("dark");
            } else {
                document.body.classList.remove("dark");
            }
        },
        imageLoadError(id) {
            console.log("Image load error for ID:", id);
            // $('#imgPro-'+id).attr('src',No_image_available);
        }, 
    }
}
</script>